import React from "react";
import { PieChart } from "@mui/x-charts/PieChart";

const SIZE = 200;
const INNER_R = 56;
const OUTER_R = 80;

const DonutChart = ({ segments, centerLabel = "0 RON", centerSub = "Total Budget" }) => {
  const segs = segments && segments.length > 0 ? segments : [];
  const total = segs.reduce((sum, s) => sum + s.pct, 0);
  const normalized = segs.map((s) => ({ ...s, pct: total > 0 ? (s.pct / total) * 100 : 0 }));

  const pieData = normalized.length > 0
    ? normalized.map((s, i) => ({ id: i, value: s.pct.toFixed(1), label: s.label, color: s.color }))
    : [{ id: 0, value: 1, color: "#f0f4ff" }];

  return (
    <div style={{ background: "white", borderRadius: 16, padding: 32, border: "1px solid #f0f4ff", boxShadow: "0 4px 20px -4px rgba(0,0,0,0.05)", height: "100%", display: "flex", flexDirection: "column" }}>
      <div style={{ marginBottom: 24 }}>
        <h6 style={{ fontWeight: 700, fontSize: "0.75rem", textTransform: "uppercase", letterSpacing: "0.08em", color: "#64748b", marginBottom: 4 }}>
          Cost Breakdown
        </h6>
        <p style={{ fontWeight: 700, fontSize: "1rem", color: "#002045", margin: 0 }}>Budget Distribution</p>
      </div>

      <div style={{ display: "flex", justifyContent: "center", marginBottom: 24 }}>
        <div style={{ position: "relative", width: SIZE, height: SIZE }}>
          <PieChart
            series={[{
              data: pieData,
              innerRadius: INNER_R,
              outerRadius: OUTER_R,
              paddingAngle: normalized.length > 0 ? 2 : 0,
              cornerRadius: 2,
            }]}
            width={SIZE}
            height={SIZE}
            slotProps={{ legend: { hidden: true } }}
            tooltip={{ trigger: "none" }}
            margin={{ top: 10, bottom: 10, left: 10, right: 10 }}
          />
          <div style={{ position: "absolute", inset: 0, display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", pointerEvents: "none" }}>
            <div style={{ fontWeight: 800, fontSize: "1rem", color: "#002045", lineHeight: 1.1, letterSpacing: "-0.02em" }}>{centerLabel}</div>
            <div style={{ fontSize: "0.7rem", fontWeight: 700, textTransform: "uppercase", letterSpacing: "0.08em", color: "#64748b", marginTop: 4 }}>{centerSub}</div>
          </div>
        </div>
      </div>

      <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
        {normalized.map((seg, i) => (
          <div key={i} style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
            <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
              <div style={{ width: 10, height: 10, borderRadius: "50%", background: seg.color, flexShrink: 0 }} />
              <span style={{ fontSize: "0.8rem", color: "#64748b", fontWeight: 500 }}>{seg.label}</span>
            </div>
            <span style={{ fontSize: "0.8rem", fontWeight: 800, color: "#002045" }}>{seg.pct.toFixed(1)}%</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default DonutChart;
